"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateRefundQuantity = updateRefundQuantity;
exports.updateRefundPrice = updateRefundPrice;
exports.hasAnyRefundItems = hasAnyRefundItems;
function updateRefundQuantity(items, index, newVal) {
    const copy = [...items];
    const current = copy[index];
    if (!current)
        return copy;
    const parsed = newVal === '' ? 0 : Number(newVal);
    const returnedAmount = Math.floor(Math.abs(parsed));
    const returnedPrice = current.returnedPrice ?? current.price;
    copy[index] = {
        ...current,
        amountInput: newVal,
        returnedAmount,
        returnedTotal: returnedAmount * returnedPrice,
    };
    return copy;
}
function updateRefundPrice(items, index, newTotal) {
    const copy = [...items];
    const current = copy[index];
    if (!current)
        return copy;
    const returnedTotal = newTotal === '' ? 0 : Number(newTotal);
    const returnedAmount = current.returnedAmount ?? current.amount;
    const returnedPrice = returnedAmount > 0 ? returnedTotal / returnedAmount : 0;
    copy[index] = {
        ...current,
        priceInput: newTotal,
        returnedPrice,
        returnedTotal,
    };
    return copy;
}
function hasAnyRefundItems(items) {
    return items.some((item) => (item.returnedTotal ?? 0) > 0);
}
